import { useTranslation } from "react-i18next";
import { Skeleton } from "@/shared/ui";
import { formatDateLong, type Locale } from "@/shared/utils";
import { useDepreciationPage } from "../../hooks";
import { DepreciationTable } from "./components";

export default function DepreciationPage() {
  const { t, i18n } = useTranslation("DepreciationPage");
  const locale = i18n.language as Locale;

  const {
    reportDate,
    depreciationReport,
    isLoading,
    isFetching,
    isError,
  } = useDepreciationPage();

  const formattedDate = formatDateLong(reportDate.toISOString(), locale);
  const subtitle = t("subtitle", { date: formattedDate, year: reportDate.getFullYear() });

  return (
    <>
      <title>{t("meta.title")}</title>
      <section className="flex-1">
        <div className="flex flex-col gap-0.5 pt-1 pb-4 border-b surface-base-stroke mb-5">
          <h1 className="text-display-xs content-base-primary">{t("title")}</h1>
          <p className="text-body-regular-md content-action-neutral">{subtitle}</p>
        </div>

        {isLoading ? (
          <div className="py-5 px-6 radius-3xl surface-base-fill">
            <div className="flex items-center gap-3 mb-6">
              <Skeleton width={300} height={24} />
            </div>
            <Skeleton width="100%" height={400} />
          </div>
        ) : (
          <DepreciationTable
            data={depreciationReport}
            isLoading={isFetching}
            error={isError ? true : undefined}
          />
        )}
      </section>
    </>
  );
}
